import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export function headStream(_x, _x2) {
  return _headStream.apply(this, arguments);
}
function _headStream() {
  _headStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, bytes) {
    var byteLengthCounter, chunks, reader, isDone, _yield$reader$read, done, value, _value$byteLength, collected, offset, _i, _chunks, chunk;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            byteLengthCounter = 0;
            chunks = [];
            reader = stream.getReader();
            isDone = false;
          case 4:
            if (isDone) {
              _context.next = 16;
              break;
            }
            _context.next = 7;
            return reader.read();
          case 7:
            _yield$reader$read = _context.sent;
            done = _yield$reader$read.done;
            value = _yield$reader$read.value;
            if (value) {
              chunks.push(value);
              byteLengthCounter += (_value$byteLength = value === null || value === void 0 ? void 0 : value.byteLength) !== null && _value$byteLength !== void 0 ? _value$byteLength : 0;
            }
            if (!(byteLengthCounter >= bytes)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("break", 16);
          case 13:
            isDone = done;
            _context.next = 4;
            break;
          case 16:
            reader.releaseLock();
            collected = new Uint8Array(Math.min(bytes, byteLengthCounter));
            offset = 0;
            _i = 0, _chunks = chunks;
          case 20:
            if (!(_i < _chunks.length)) {
              _context.next = 32;
              break;
            }
            chunk = _chunks[_i];
            if (!(chunk.byteLength > collected.byteLength - offset)) {
              _context.next = 27;
              break;
            }
            collected.set(chunk.subarray(0, collected.byteLength - offset), offset);
            return _context.abrupt("break", 32);
          case 27:
            collected.set(chunk, offset);
          case 28:
            offset += chunk.length;
          case 29:
            _i++;
            _context.next = 20;
            break;
          case 32:
            return _context.abrupt("return", collected);
          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _headStream.apply(this, arguments);
}